const CloudPayIn =  {
  CC : 'CreditCard',
  DC : 'DebitCard',
  AC : 'ACH',
  EB : 'WUPay',
  IA : 'iACH',
  CA : 'AG',
  SF : 'Sofort',
  AP : 'AP',
  TR : 'Trustly',
  SD : 'IDEAL',
  PL : 'POLI',
  PC : 'Paramount',
  TG : 'TapNGo',
  FP : 'FPX',
  PF : 'PartnerFunds',
  BA : 'BankAccount',
  GP : 'GooglePay',
  DI : 'DebitCardInterChange',
  PA : 'Plaid',
  PN : 'PayNow',
  IR : 'Interac'
}

const CloudPayInNames = {
  CC: "Credit Card",
  DC: "Debit Card",
  AC: "ACH",
  EB: "WUPay",
  IA: "iACH",
  CA: "AG",
  SF: "Sofort",
  AP: "AP",
  TR: "Trustly",
  SD: "IDEAL",
  PL: "POLI",
  PC: "Paramount",
  TG: "TapNGo",
  FP: "FPX",
  PF: "Partner Funds",
  BA: "Bank Account",
  GP: "Google Pay",
  DI: "Debit Card InterChange",
  PA: "Plaid",
  PN: "Pay Now",
  IR: "Interac"
};

const CloudPayOut =  {
  MM : 'AG',
  DB : 'BA',
  ND : 'ND',
  MB : 'MT',
  DC : 'WA',
  D2 : 'D2C',
  AG : 'AG', // Cash
}

const CloudPayOutNames = {
  MM: "AG",
  DB: "BA",
  ND: "ND",
  MB: "MT",
  DC: "WA",
  D2: "D2C",
  AG: "AG", // Cash
};

const CloudPayOutCodeMapping = {
    MM: '000',
    DB: '500',
    ND: 'ND',//kiosk related so not covered 
    MB : '600',
    DC : '800',
    DC_1 : '801', //Adding sub channels
    D2 : '200',
    D2_1 : '201',
    D2_2 : '202',
    AG : '000',
    HD : '700',
    AGMexico : '400'
  }

const AmerigoPayOut =  {
  DB : 'bank_transfer',
  MM : 'cash',
  DC: 'mobile_money'
}

const AmerigoPayIn =  {
  AG : 'stage_and_pay',
  DC : 'direct_debit',
  CC : 'credit_card',
  CA : 'stage_and_pay'
}

const ChangeCountryCurrency = {
  BA: 'BAM',
  RU: 'RUB',
  UY: 'UYP',
  VE: 'VEF',
  ST: 'STD'
};

const PayOutCodeNames = {
    '000' : 'AG',
    '600' : 'MT',
    '500' : 'BA',
    '800' : 'WA',
    '200' : 'D2C',
    '041' : 'AG',
    '400' : 'AG',
    'M10' : 'AG',
    'M11' : 'AG',
    'M12' : 'AG',
    'M13' : 'AG',
    'M14' : 'AG',
    'M15' : 'AG',
    'M16' : 'AG',
    'M17' : 'AG',
    'M18' : 'AG'
};

const USAStates = {
  'AA': 'Aa-US Military', 'AE': 'Ae-US Military', 'AK': 'Alaska', 'AL': 'Alabama', 'AP': 'Ap-US Military', 'AR': 'Arkansas',
  'AZ': 'Arizona', 'CA': 'California', 'CO': 'Colorado', 'CT': 'Connecticut', 'DC': 'Dist Of Col', 'DE': 'Delaware',
  'FL': 'Florida', 'GA': 'Georgia', 'GU': 'Guam', 'HI': 'Hawaii', 'IA': 'Iowa', 'ID': 'Idaho',
  'IL': 'Illinois', 'IN': 'Indiana', 'KS': 'Kansas', 'KY': 'Kentucky', 'LA': 'Louisiana', 'MA': 'Massachusetts',
  'MD': 'Maryland', 'ME': 'Maine', 'MI': 'Michigan', 'MN': 'Minnesota', 'MO': 'Missouri', 'MP': 'Northern Mariana Islands',
  'MS': 'Mississippi', 'MT': 'Montana', 'NC': 'North Carolina', 'ND': 'North Dakota', 'NE': 'Nebraska', 'NH': 'New Hampshire',
  'NJ': 'New Jersey', 'NM': 'New Mexico', 'NV': 'Nevada', 'NY': 'New York', 'OH': 'Ohio', 'OK': 'Oklahoma',
  'OR': 'Oregon', 'PA': 'Pennsylvania', 'PR': 'Puerto Rico', 'RI': 'Rhode Island', 'SC': 'South Carolina', 'SD': 'South Dakota',
  'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah', 'VA': 'Virginia', 'VI': 'Virgin Islands', 'VT': 'Vermont',
  'WA': 'Washington', 'WI': 'Wisconsin', 'WV': 'West Virginia', 'WY': 'Wyoming'
}

const CanadaStates = {
  'AB': 'Alberta', 'BC': 'British Columbia', 'MB': 'Manitoba', 'NB': 'New Brunswick', 'NL': 'Newfoundland and Labrador',
  'NS': 'Nova Scotia', 'NT': 'Northwest Territories', 'NU': 'Nunavut', 'ON': 'Ontario', 'PE': 'Prince Edward Island',
  'QC': 'Quebec', 'SK': 'Saskatchewan', 'YT': 'Yukon'
}

const MexicoStates = [{"name":"Distrito Federal","code":"IF"},{"name":"Aguascalientes","code":"GU"},{"name":"Baja California","code":"CN"},{"name":"Baja California Sur","code":"CS"},{"name":"Campeche","code":"AM"},{"name":"Chiapas","code":"HP"},{"name":"Chihuahua","code":"HH"},{"name":"Coahuila","code":"OA"},{"name":"Colima","code":"OL"},{"name":"Durango","code":"UR"},{"name":"Guanajuato","code":"UA"},{"name":"Guerrero","code":"RO"},{"name":"Hidalgo","code":"ID"},{"name":"Jalisco","code":"AL"},{"name":"Michoacán","code":"IC"},{"name":"Morelos","code":"OR"},{"name":"México","code":"EX"},{"name":"Nayarit","code":"AY"},{"name":"Nuevo León","code":"LE"},{"name":"Oaxaca","code":"AX"},{"name":"Puebla","code":"UE"},{"name":"Querétaro","code":"UE"},{"name":"Quintana Roo","code":"OO"},{"name":"San Luis Potosí","code":"LP"},{"name":"Sinaloa","code":"IN"},{"name":"Sonora","code":"ON"},{"name":"Tabasco","code":"AB"},{"name":"Tamaulipas","code":"AM"},{"name":"Tlaxcala","code":"LA"},{"name":"Veracruz","code":"ER"},{"name":"Yucatán","code":"UC"},{"name":"Zacatecas","code":"AC"}]